import { render, staticRenderFns } from "./PublishDialog.vue?vue&type=template&id=f87a56f2&scoped=true"
import script from "./PublishDialog.vue?vue&type=script&lang=ts"
export * from "./PublishDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87a56f2",
  null
  
)

export default component.exports